import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string"
import {CustomFieldAccessOptions} from "./@const"
import FieldDropdown from "../../fields3/generic/dropdown/dropdown"
import FieldMultiselect from "../../fields3/generic/multiselect/multiselect";

const baseConfig = [
    {
        fieldId     : 'name',
        label       : 'System Name',
        type        : FieldType.STRING,
        description : 'A unique internal identifier used when managing custom fields, adding them to projects or task types, and configuring integrations or automations.'
    },

    {
        fieldId     : 'displayName',
        label       : 'Display Name',
        type        : FieldType.STRING,
        description : 'The name shown to users in the interface. Use this if you want it to differ from the system name.'
    },

    {
        fieldId         : 'access',
        label           : 'Display to',
        type            : FieldType.DROPDOWN,
        description     : 'Choose who can see this custom field: either all users (\'Everyone\') or only organization managers.',
        options         : CustomFieldAccessOptions,
        noValueOption   : false,
        showMenuMore    : false
    },

]

export default class CustomFieldFields extends FieldsCollection {

    // Quick access
    get name()              : FieldString { return this.get('name') as FieldString }
    get displayName()       : FieldString { return this.get('displayName') as FieldString }
    get access()            : FieldDropdown { return this.get('access') as FieldDropdown }

    constructor() {
        super(baseConfig, EntityType.CUSTOM_FIELD)
    }
}
